import React, { useState, useEffect } from "react";
import axios from 'axios';
import { API_BASE_URL } from "../../../src/config";
import { Container, Row, Col, Card, Table, Badge, Button, Alert } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminGeralLayout from "../../components/AdminGeralLayout/AdminGeralLayout";

function AdminGeralDashboard() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    carregarDashboard();
  }, []);

  const carregarDashboard = async () => {
    try {
      const token = Cookies.get("authToken");
      const response = await axios.get(`${API_BASE_URL}/admin-geral/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDashboard(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar dashboard.");
      setLoading(false);
    }
  };



  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  return (
    <AdminGeralLayout activeKeyProp="dashboard">
      <div className="mb-4">
        <h1>Dashboard</h1>
        <p className="text-muted">Visão geral do sistema MarcaAi.</p>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <>
          {erro && <Alert variant="danger">{erro}</Alert>}

          {/* Cards de Resumo */}
          <Row className="mb-4">
            <Col md={3}>
        <Card className="shadow-sm" style={{width: "95%"}}>
                <Card.Body>
                  <h6 className="text-muted">Total de Clientes</h6>
                  <h2 className="mb-0">{dashboard?.totalClientes || 0}</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
        <Card className="shadow-sm" style={{width: "95%"}}>
                <Card.Body>
                  <h6 className="text-muted">Clientes Ativos</h6>
                  <h2 className="mb-0 text-success">{dashboard?.clientesAtivos || 0}</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
        <Card className="shadow-sm" style={{width: "95%"}}>
                <Card.Body>
                  <h6 className="text-muted">Faturamento Mensal</h6>
                  <h2 className="mb-0 text-primary">{formatarMoeda(dashboard?.valorFaturadoMensal || 0)}</h2>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
        <Card className="shadow-sm" style={{width: "95%"}}>
                <Card.Body>
                  <h6 className="text-muted">Próximos ao Vencimento</h6>
                  <h2 className="mb-0 text-warning">{dashboard?.qtdClientesProximosVencimento || 0}</h2>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tabela de Clientes Próximos ao Vencimento */}
        <Card className="shadow-sm" style={{width: "95%"}}>
            <Card.Header>
              <h5 className="mb-0">Clientes Próximos ao Vencimento</h5>
            </Card.Header>
            <Card.Body>
              {dashboard?.clientesProximosVencimento && dashboard.clientesProximosVencimento.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Celular</th>
                      <th>Data Vencimento</th>
                      <th>Dias Restantes</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboard.clientesProximosVencimento.map((cliente) => (
                      <tr key={cliente.Id}>
                        <td>{cliente.Nome}</td>
                        <td>{cliente.Celular}</td>
                        <td>{formatarData(cliente.DataVencimento)}</td>
                        <td>
                          <Badge bg={cliente.DiasRestantes <= 3 ? "danger" : "warning"}>
                            {cliente.DiasRestantes} dias
                          </Badge>
                        </td>
                        <td>
                          <Button 
                            size="sm" 
                            variant="primary"
                            onClick={() => navigate(`/admin-geral/clientes-master/${cliente.Id}/renovar`)}
                          >
                            Renovar
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-muted">Nenhum cliente próximo ao vencimento.</p>
              )}
            </Card.Body>
          </Card>
        </>
      )}
    </AdminGeralLayout>
  );
}

export default AdminGeralDashboard;
